var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "col-lg-5 col-md-6 col-sm-12 relative-position row items-center",
        attrs: { id: "forgot-password-left" }
      },
      [
        !_vm.$route.query.token
          ? _c(
              "q-card-main",
              { staticClass: "content-center col-12" },
              [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "q-pa-md" }, [
                      _vm._v("Forgot Password")
                    ]),
                    _c(
                      "q-field",
                      { staticClass: "q-pa-md" },
                      [
                        _c("q-input", {
                          attrs: {
                            name: "",
                            autofocus: "",
                            value: _vm.forgotPasswordForm.email,
                            clearable: "",
                            "float-label": "Email",
                            before: [{ icon: "email" }]
                          },
                          on: {
                            input: function(val) {
                              return _vm.updateForgotPasswordForm({
                                field: "email",
                                value: val
                              })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "q-field",
                          { staticClass: "q-pa-md" },
                          [
                            _c("q-btn", {
                              attrs: {
                                label: "Send Reset Email",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.forgotPasswordHandler()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("q-field", { staticClass: "outline col-12" }, [
                  _c("span", { staticClass: "text-bold" }, [
                    _vm._v("OR LOG-IN")
                  ]),
                  _c(
                    "div",
                    { staticClass: "float-right" },
                    [
                      _c("q-btn", {
                        attrs: {
                          size: "sm",
                          label: "Login",
                          color: "secondary",
                          outline: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.goToLogin()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.$route.query.token
          ? _c(
              "q-card-main",
              { staticClass: "content-center col-12" },
              [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c("h5", { staticClass: "q-pa-md" }, [
                      _vm._v("Change Password")
                    ]),
                    _c(
                      "q-field",
                      {
                        staticClass: "q-pa-sm",
                        attrs: {
                          error: _vm.$v.changePasswordForm.password.$error,
                          "error-label":
                            "Length must be between 6 and 20 characters"
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "New Password",
                            type: "password",
                            before: [{ icon: "lock" }],
                            value: _vm.changePasswordForm.password,
                            required: ""
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateChangePasswordForm({
                                field: "password",
                                value: $event.target.value
                              })
                            },
                            input: function($event) {
                              _vm.$v.changePasswordForm.password.$touch()
                            },
                            blur: function($event) {
                              _vm.$v.changePasswordForm.password.$touch()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-field",
                      {
                        staticClass: "q-pa-sm",
                        attrs: {
                          error:
                            _vm.$v.changePasswordForm.confirmPassword.$error,
                          "error-label": "Must match set password"
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "Confirm Password",
                            type: "password",
                            before: [{ icon: "lock" }],
                            value: _vm.changePasswordForm.confirmPassword,
                            required: ""
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateChangePasswordForm({
                                field: "confirmPassword",
                                value: $event.target.value
                              })
                            },
                            input: function($event) {
                              _vm.$v.changePasswordForm.confirmPassword.$touch()
                            },
                            blur: function($event) {
                              _vm.$v.changePasswordForm.confirmPassword.$touch()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "q-field",
                          { staticClass: "q-pa-md" },
                          [
                            _c("q-btn", {
                              attrs: {
                                label: "Change Password",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.resetPasswordHandler()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("q-field", { staticClass: "outline col-12" }, [
                  _c("span", { staticClass: "text-bold" }, [
                    _vm._v("OR LOG-IN")
                  ]),
                  _c(
                    "div",
                    { staticClass: "float-right" },
                    [
                      _c("q-btn", {
                        attrs: {
                          size: "sm",
                          label: "Login",
                          color: "secondary",
                          outline: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.goToLogin()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _c("div", {
      staticClass: "col-lg-7 col-md-6 relative-position mobile-hide",
      attrs: { id: "forgot-password-picture" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }